<div class="notes-panel" *ngIf="isOpen" #notesPanel
     [style.width.px]="panelWidth" [style.height.px]="panelHeight">
  <span class="notes-resize-handle" (mousedown)="startResize($event)" title="Drag to resize"></span>
  <div class="notes-header">
    <span class="notes-title">Chat</span>
    <span class="notes-subtitle">Production ↔ Clearance</span>
    <button mat-icon-button type="button" class="notes-minimize" (click)="toggle()" aria-label="Minimize notes">
      <mat-icon>remove</mat-icon>
    </button>
  </div>
  <div class="notes-body" #notesBody>
    <div *ngIf="filteredNotes.length === 0" class="notes-empty">No messages yet.</div>
    <div *ngFor="let note of filteredNotes" class="note-item" [ngClass]="{'note-unread': isUnread(note)}">
      <div class="note-top">
        <span class="note-role-badge" [ngClass]="{'role-production': note.role === 'Production', 'role-clearance': note.role === 'Clearance'}">
          {{note.role | uppercase}}
        </span>
        <span class="note-date"><span *ngIf="note.lastModifiedById">Edited · </span>{{formatDate(note.createdDate)}}</span>
        <span class="note-actions" *ngIf="canEdit(note)">
          <ng-container *ngIf="editingNote?.id !== note.id">
            <button mat-icon-button type="button" class="note-action-icon" (click)="startEdit(note)" aria-label="Edit note">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button type="button" class="note-action-icon note-delete" (click)="removeNote(note)" aria-label="Delete note">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf="editingNote?.id === note.id">
            <button mat-icon-button type="button" class="note-action-icon note-save" (click)="saveEdit()" aria-label="Save note">
              <mat-icon>check</mat-icon>
            </button>
            <button mat-icon-button type="button" class="note-action-icon" (click)="cancelEdit()" aria-label="Cancel edit">
              <mat-icon>close</mat-icon>
            </button>
          </ng-container>
        </span>
      </div>
      <div class="note-description" *ngIf="editingNote?.id !== note.id">{{note.description}}</div>
      <textarea *ngIf="editingNote?.id === note.id" class="note-edit-input" [(ngModel)]="editText"></textarea>
      <div class="note-bottom">
        <span class="note-user">{{note.user}}</span>
        <span class="note-viewed-status">{{ getViewedStatus(note) }}</span>
      </div>
    </div>
  </div>
  <div class="notes-footer">
    <textarea [(ngModel)]="newNoteText" placeholder="Leave a message for the other team..." (keyup.enter)="addNote()" [disabled]="isSending"></textarea>
    <div class="notes-actions">
      <div class="role-toggle">
        <button type="button" class="role-btn" [ngClass]="{'role-btn-active': filterRole === 'Production'}" (click)="toggleFilter('Production')">Production</button>
        <button type="button" class="role-btn" [ngClass]="{'role-btn-active': filterRole === 'Clearance'}" (click)="toggleFilter('Clearance')">Clearance</button>
      </div>
      <button type="button" class="send-btn" (click)="addNote()" [disabled]="isSending">
        <span *ngIf="!isSending">Send</span>
        <span *ngIf="isSending" class="send-spinner" aria-label="Sending"></span>
      </button>
    </div>
  </div>
</div>
